import { useState, useEffect } from "react";
import { MovimientosModel } from "../models/MovimientosModel";
import { getMovimientos, getWalletUsersByNombre } from "../../../../service/enlistment";
import { SimpleAlert } from "../../../../../rbts/helpers";

export interface WalletUserMatch {
  id: number;
  nombre: string;
  email: string;
  folio: string | null;
}

export const useMovimientosTicket = (realoadGrid: number, ticket: string) => {

  const [list, setList] = useState<MovimientosModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(false);

  useEffect(() => {

    const fetchPost = async () => {
      setLoadingRequest(true);
      const res = await getMovimientos(ticket)
        .then()
        .catch((error) => {
          const message = error.response.data.message;
          SimpleAlert(
            message,
            3000,
            "error");
          setLoadingRequest(false);
        });
      if (res) {
        setList(res);
        setLoadingRequest(false);
      }
    };
    if(ticket !== ""){
      fetchPost();
    }else{
      setLoadingRequest(false);
      setList([]);
    }

  }, [realoadGrid]);

  return { list, loadingRequest };
};

export const useWalletUsersByNombre = (reloadGrid: number, nombre: string) => {

  const [matches, setMatches] = useState<WalletUserMatch[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(false);

  useEffect(() => {
    if (nombre.trim().length >= 2) {
      const fetchData = async () => {
        setLoadingRequest(true);
        const res = await getWalletUsersByNombre(nombre)
          .then()
          .catch((error) => {
            const message = error?.response?.data?.message || 'Error al buscar';
            SimpleAlert(message, 3000, 'error');
            setLoadingRequest(false);
          });
        if (res) {
          setMatches(res);
          setLoadingRequest(false);
        }
      };
      fetchData();
    } else {
      setMatches([]);
    }
  }, [reloadGrid]);

  return { matches, loadingRequest };
};
